import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { URLS } from "utils/constants";
import {
  IconMilitaryRank,
  IconGift,
  IconSettings2,
  IconLock,
  IconSettings,
} from "@tabler/icons-react";
import "./AgentRankNavigationMenu.css";

const AgentRankNavigationMenu = () => {
  const location = useLocation();

  const menuItems = [
    {
      name: "Rank",
      href: URLS.v1.AGENTRANK,
      icon: IconMilitaryRank,
    },
    {
      name: "Reward",
      href: URLS.v1.AGENTRANK_REWARD,
      icon: IconGift,
    },
    {
      name: "Reward Management",
      href: URLS.v1.AGENTRANK_REWARD_CRUD,
      icon: IconSettings2,
    },
    {
      name: "Pinalty",
      href: URLS.v1.AGENTRANK_PINALTY,
      icon: IconLock,
    },
    {
      name: "Setting",
      href: URLS.v1.AGENTRANK_SETTING,
      icon: IconSettings,
    },
  ];

  // Check if current path is under Agent Rank section
  const isAgentRankPath = location.pathname.startsWith("/v1/agent-rank");

  if (!isAgentRankPath) return null;

  return (
    <div className="agent-rank-navigation-wrapper">
      <div className="agent-rank-navigation-container">
        <div className="agent-rank-navigation-tabs">
          {menuItems.map((item, index) => {
            const IconComponent = item.icon;
            const isActive = location.pathname === item.href;
            
            return (
              <NavLink
                key={index}
                to={item.href}
                className={`agent-rank-nav-tab ${isActive ? "active" : ""}`}
              >
                <IconComponent size={18} />
                <span>{item.name}</span>
              </NavLink>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AgentRankNavigationMenu;